// @ts-nocheck
import { BecomeADistributorModel } from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/BecomeADistributorFormTypes";
import { getIsDistributorFormLoadingSelector } from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/DistributorFormSelector";
import sendBecomeADistributorForm from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/Handlers/SendBecomeADistributorForm";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { useDispatch } from "react-redux";

export const useSendBecomeADistributor = () => {
    const dispatch = useDispatch();
    return (fields: BecomeADistributorModel, onSuccess: () => void, onError: (errorMessage: string) => void) =>
        dispatch(
            sendBecomeADistributorForm({
                ...fields,
                onError,
                onSuccess,
            }),
        );
};

export const useIsDistributorFormLoading = () => {
    return useAppSelector(state => getIsDistributorFormLoadingSelector(state));
};
